var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-black bg-opacity-50 fixed grid h-full inset-0 place-items-center w-full z-100"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }